import { ColumnState } from 'ag-grid-community';
import {
    createFormGroupState, formGroupReducer, FormGroupState, updateGroup, validate
} from 'ngrx-forms';
import { email } from 'ngrx-forms/validation';

import { BaseDocumentDownload } from '../../base/base-document-download';
import { User } from '../user.model';
import { UsersActions, UsersActionTypes } from './user.actions';

export const USER_LIST_FORM_ID = 'userListForm';
export interface UserListFilterFormValue {
    name: string;
    fiscalCode: string;
    email: string;
}
export interface UsersState {
    usersList: User[];
    loaded: boolean;
    userListFilterForm: FormGroupState<UserListFilterFormValue>;
    gridColumnState: ColumnState[];
    downloadedDocuments: BaseDocumentDownload[];
}

export const initialState: UsersState = {
    usersList: [],
    loaded: false,
    gridColumnState: [],
    userListFilterForm: createFormGroupState<UserListFilterFormValue>(USER_LIST_FORM_ID, {
        name: '',
        fiscalCode: '',
        email: ''
    }),
    downloadedDocuments: null
};

export const validateUserListForm = updateGroup<UserListFilterFormValue>({
    email: validate(email)
});

export function usersReducer(state = initialState, action: UsersActions): UsersState {
    const listForm = validateUserListForm(formGroupReducer(state.userListFilterForm, action));
    if (listForm !== state.userListFilterForm) {
        state = { ...state, userListFilterForm: listForm };
    }

    switch (action.type) {

        case UsersActionTypes.LoadUsersSuccess:
            return {
                ...state,
                usersList: action.payload,
                loaded: true
            };

        case UsersActionTypes.LoadUsersFail:
            return {
                ...state,
                loaded: false
            };

        case UsersActionTypes.UpdateUserSuccess:
            {
                const newUsers: User[] = [...state.usersList];
                const itemToUpdate = newUsers.find((value) => {
                    return value.id === action.user.id;
                });
                const index = newUsers.indexOf(itemToUpdate);
                newUsers[index] = action.user;
                return {
                    ...state,
                    usersList: newUsers
                };
            }

        case UsersActionTypes.CreateUserSuccess:
            {
                const newUsers: User[] = [...state.usersList];
                newUsers.push(action.user);
                return {
                    ...state,
                    usersList: newUsers
                };
            }
        case UsersActionTypes.DeleteUserSuccess:
            {
                const index = state.usersList.findIndex(u => u.id === action.user.id);
                const newUsers: User[] = [...state.usersList];
                newUsers.splice(index, 1);
                return {
                    ...state,
                    usersList: newUsers
                };
            }
        case UsersActionTypes.ClearUsers:
            return {
                ...state,
                usersList: [],
                loaded: false
            };
        case UsersActionTypes.SortUsers:
            {
                return {
                    ...state,
                    gridColumnState: action.columnState
                };
            }
        case UsersActionTypes.CancellationRequestSuccess: {
            const newUsers: User[] = [...state.usersList];
                const itemToUpdate = newUsers.find((value) => {
                    return value.id === action.user.id;
                });
                const index = newUsers.indexOf(itemToUpdate);
                newUsers[index] = action.user;
                return {
                    ...state,
                    usersList: newUsers
                };
        }
        case UsersActionTypes.DownloadDocumentsSuccess: {
            return {
                ...state,
                downloadedDocuments: [...action.payload]
            };
        }
        case UsersActionTypes.DownloadedDocumentsSuccess: {
            return {
                ...state,
                downloadedDocuments: null
            };
        }
        default:
            return state;
    }
}

